import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import AgoraRTC from "agora-rtc-sdk-ng";
import useAppDispatch from '../../../../hooks/useAppDispatch';
import useAppAccessor from '../../../../hooks/useappAccessor';
import { changeAudio, changeVideo } from "../../components/streamControls/controls.actions";
import close from '../../../../assets/icons/close.svg';
const CamSelector = (props: any) => {
    const dispatch = useAppDispatch();
    const [cameraDevices, setCameraDevices] = useState<MediaDeviceInfo[]>([]);
    const [selectedCamera, setSelectedCamera] = useState('');
    const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
    const { getControls } = useAppAccessor();
    const { newVideoStream, newAudioStream } = getControls();
    const { getUserData } = useAppAccessor();
    const { language, client } = getUserData();

    const handleSelectDevice = (deviceId: string) => {
      setSelectedDeviceId(deviceId);
      handleCameraChange(deviceId);
      setTimeout(() => {
      props.toggleVisible();
      } , 100);
    };

    const handleCameraChange = async (deviceId: string) => {
      setSelectedCamera(deviceId);
      const stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId } });
      const videoTrack = stream.getVideoTracks()[0];
      if (videoTrack) {
        dispatch(changeVideo(deviceId));
      }
    };

    useEffect(() => {
        const getCameraDevices = async () => {
          const devices = await AgoraRTC.getCameras();
          setCameraDevices(devices);
          if(newVideoStream){
            setSelectedCamera(newVideoStream);
            setSelectedDeviceId(newVideoStream);
          }
          if (devices.length > 0) {
            // setSelectedCamera(devices[0].deviceId);
            // setSelectedDeviceId(devices[0].deviceId);
          }
        };
        getCameraDevices();
      }, []);

  return (
    <div className="audio-selector-container">
      {(
        <div className="dropdown" id={'camSelector'}>
          <button onClick={() => {
            props.toggleVisible();
          }} style={{ position: 'absolute', top: '10px', right: '10px' }}>
              <img
                    src={close}
                    alt="close"
                    height={24}
                    width={24}
                    style={{ height: "24px" , margin: '3px' }}
                    className="cursor-pointer"
                  ></img>
          </button>
          <h3>{language['select_camera']}</h3>
          <ul>
            {cameraDevices.map((device) => (
              <li 
              onClick={() => handleSelectDevice(device.deviceId)}
              style={{ cursor: 'pointer' }}
              key={device.deviceId}
              >{selectedDeviceId === device.deviceId ? '• ' : ''}{device.label}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CamSelector;
